// animation observer
const animationObserver = () => {
  //Intersection observer for animations-----------------------------------------------------------
  let optionsForAnimations = {
    threshold: [0, 0.25, 0.5, 0.75, 1],
  };

  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const { delay, animname, onetime, animtiming, timingfunction } =
        entry.target.dataset;

      if (entry.intersectionRatio > 0) {
        entry.target.style.animation = `${animname} ${animtiming || 0.5}s ${
          timingfunction || `ease`
        } ${delay || 0}s forwards`;
      } else if (onetime) return;
      else {
        entry.target.style.animation = `none`;
      }
    });
  }, optionsForAnimations);

  const prepareAnimation = (element) => {
    const { animname } = element.dataset;
    element.classList.add(animname);
  };

  const selectors = [`[data-animname]`];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      if (!element) return;

      prepareAnimation(element);
      animationObserver.observe(element);
    });
  });
};

// watch Animations
animationObserver();

// appply slick and slick

$(document).ready(function () {
  console.log("slick loaded");

  $(".hero-slider").slick({
    dots: false,
    infinite: true,
    speed: 2000,
    fade: false,
    cssEase: "ease",
    autoplay: true,
    autoplaySpeed: 4000,
    // adaptiveHeight: true,
  });

  $(".slider").slick({
    dots: false,
    infinite: true,
    speed: 2000,
    fade: false,
    cssEase: "ease",
    autoplay: true,
    autoplaySpeed: 4000,
    // adaptiveHeight: true,
  });

  $(".yt-video-slider-container").slick({
    dots: false,
    infinite: true,
    speed: 1000,
    fade: false,
    cssEase: "ease",
    autoplay: true,
    autoplaySpeed: 4000,
  });

  $(".product-media-slider").slick({
    dots: false,
    infinite: true,
    speed: 1000,
    fade: false,
    cssEase: "ease",
    autoplay: true,
    autoplaySpeed: 4000,
  });

  $(".testimonial-slider").slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: "ease",
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });
});

// header changes
const header = $("#shopify-section-header .site-header")[0];

window.onscroll = (e) => {
  if (pageYOffset > 130) {
    header.classList.add("header-with-bg");
  } else {
    header.classList.remove("header-with-bg");
  }
};

// ham  click
const hamContainer = $("#ham-icon-container")[0];
const headerMain = $("#shopify-section-header")[0];
hamContainer.addEventListener("click", () => {
  header.classList.toggle("show-header");
  headerMain.classList.remove("enable-pointer-events");

  if (header.classList.contains("show-header")) {
    headerMain.classList.add("enable-pointer-events");
  }
});

// fixing the header in the mobile view if accountment bar is present
const announcementBar = document.querySelector(".announcement-bar");

if (announcementBar) {
  const logoContainer = document.querySelector(
    "#shopify-section-header .mobile-logo"
  );
  const hamMenu = document.querySelector("#ham-icon-container");
  const pageContainer = document.querySelector(".page-container");
  const height = announcementBar.getBoundingClientRect().height;

  logoContainer.style.top = `calc(${height}px + 1rem)`;
  hamMenu.style.top = `calc(${height}px + 2rem)`;
  pageContainer.style.paddingTop = `${height}px`;

  console.log("fixing top ran");
}
